// extracted by mini-css-extract-plugin
export var chevronIcon = "_8r-2";
export var teamName = "_8r-1";
export var teamSwitcherButton = "_8r-0";